import { GroupChannel } from '@sendbird/chat/lib/__definition';

import { SBMemberMetaData } from 'app/api/SBChat';

export const getCurrentCompanyMembers = (currentChannel: GroupChannel | undefined, activeUserCompanyId: string) =>
  currentChannel?.members.filter(
    (member) => (member?.metaData as SBMemberMetaData)?.company_id === activeUserCompanyId,
  ) ?? [];
